import React from "react";
import {
  TextField,
  Autocomplete,
} from "@mui/material";

const DynamicSelect = ({
  label = "Sort by",
  selectValue = "",
  onSortChange,
  options = [],
  minWidth = 120,
  disabled = false,
}) => {
  const handleChange = (_event, newValue) => {
    if (onSortChange) {
      onSortChange(newValue ? newValue.value : "");
    }
  };

  // Find the currently selected option
  const selectedOption = options.find((opt) => opt.value === selectValue) || null;

  return (
    <Autocomplete
      size="small"
      disabled={disabled}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      getOptionLabel={(option) => option.label || ""}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      sx={{ minWidth: minWidth }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};

export default DynamicSelect;